let shouldShowDialog = false;

export const setShowDialog = (shouldShow: boolean) => {
  shouldShowDialog = shouldShow;
};

export const init = () => {
  window.onbeforeunload = () => {
    return shouldShowDialog || null;
  };
};
